import { FC } from "react";
import muiIcons from "../icons/mui-icons";
import { Box, styled } from "@mui/system";
import { Paragraph } from "../Typography";
import { Avatar, InputBase, List } from "@mui/material";
import { themeShadows } from "../../theme/themeColors";

export const ChatHeader = styled(Box)(({ theme }) => ({
  height: "50px",
  padding: "5px 15px",
  boxShadow: themeShadows[1],
}));

const Search = styled("div")(({ theme }) => ({
  width: "220px",
  position: "relative",
  borderRadius: "50px",
  backgroundColor: theme.palette.mode === "light"
    ? theme.palette.grey[100] : "#0000002e",
  "&:hover": {
    backgroundColor: theme.palette.mode === "light" && theme.palette.grey[200],
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: "5px 12px",
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& svg": {
    fontSize: 22,
    color: theme.palette.grey.main,
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: "8px 5px 8px 5px",
    paddingLeft: "40px",
    width: "100%",
  },
}));

const ChatList = styled(List)(({ theme }) => ({
  padding: 0,
  cursor: "pointer",
  overflowY: "auto",
  height: "calc(100% - 50px)",
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  "& :hover": {
    background: theme.palette.mode === "light" ? theme.palette.grey[50] : "#0000002e",
  },
}));

const ChatListItem = styled(Box)<{ status: string }>(({ theme, status }) => ({
  display: "flex",
  padding: "20px 15px",
  position: "relative",
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  "&:before": {
    position: "absolute",
    content: '""',
    width: "8px",
    height: "8px",
    top: "calc(50% - 4px)",
    right: "30px",
    background: status === "active" ? "#10b981" : "#6b7280",
    borderRadius: "50%",
  },
  "& :hover": {
    background: 'transparent',
  },
}));

interface Props {
  filteredChat: any[];
  setSearchValue: (value: string) => void;
  findUserChat: (id: number) => void;
}
const UserChatList: FC<Props> = (props) => {
  const { SearchIcon } = muiIcons;
  const { filteredChat, setSearchValue, findUserChat } = props;
  return (
    <>
      <ChatHeader display="flex" alignItems="center" justifyContent="center">
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search By Name"
            inputProps={{ "aria-label": "search" }}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </Search>
      </ChatHeader>

      <ChatList>
        {filteredChat.map((data) => {
          const { id, name, status, photoUrl } = data;
          return (
            <ChatListItem status={status} onClick={() => findUserChat(id)}>
              <Avatar
                src={photoUrl}
                sx={{ mr: "10px", width: 35, height: 35 }}
              />
              <Box>
                <Paragraph>{name}</Paragraph>
              </Box>
            </ChatListItem>
          );
        })}
      </ChatList>
    </>
  );
};

export default UserChatList;
